export enum DesignFeature {
  CreateOffset,
  InterpolatePointHeights,
  Triangulate,
  SetPointHeights,
  Import,
  GenerateGrid,
  GenerateLineSegments,
  CreatePoints,
}
